import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchAreas } from '@/features/areas/api'
import { fetchUnkoudateContract } from '@/features/contracts/api'
import { contractParamsSchema } from '@/routes/_protected/$tenantKey/settings/contracts/-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/contracts/tour/$contractId'
)({
  parseParams: (params) => parse(contractParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, contractId },
    context: { auth }
  }) => {
    const [contract, areaSelectList] = await Promise.all([
      fetchUnkoudateContract({ tenantKey, contractId }, abortController.signal),
      fetchAreas({ tenantKey }, abortController.signal)
    ])
    return {
      authUser: auth.user,
      contract,
      areaSelectList
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.contract.name
    }
  ]
})
